import { chartColors } from './chart.constant';

export function getDataColorByIndex(index: number) {
  return chartColors[index % chartColors.length];
}
